import React, { useState } from 'react';
import { getTime } from '../../../utils/dateTimeUtil';
import { makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setDate, setHour } from '../../../redux/Appointment/AppointmentAction';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment-jalaali';
import ADD_ICON from '../../../assets/images/add.png';
import ARROW_ICON from '../../../assets/images/left.png';
import AppointmentListMenu from './AppointmentListMenu';
import { useRef } from 'react';
const styles = makeStyles({
    cellItem: {
        display: 'flex',
        maxWidth: '100%',
        backgroundColor: '#d6e9fe',
        color: '#003d5b',
        borderRadius: '10px',
        justifyContent: 'space-between',
        fontSize: '13px',
        padding: '0 5px',
        marginBottom: '1px',
        '&:last-child': {
            marginBottom: '0'
        },
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#55a6fa'
        }
    },
    time: {
        fontWeight: 'bold'
    },
    cell: {
        height: '108px',
        borderBottom: '1px dashed #d8d8d8',
        position: 'relative',
        '&:hover': {
            backgroundColor: '#e6ebee80',
            '& *': {
                opacity: '1 !important'
            }
        },
        '&:last-child': {
            borderBottom: 'none'
        }
    },
    name: {
        maxWidth: '130px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    innerCellContainer: {
        height: '83px',
        overflow: 'hidden'
    },
    moreContainer: {
        height: '23px',
        paddingTop: '4px',
        paddingRight: '10px',
        lineHeight: '1.7',
        fontWeight: 'bold',
        color: '#363636'
    },
    moreLink: {
        cursor: 'pointer',
        fontSize: '10px'
    },
    plusLink: {
        position: 'absolute',
        left: '0',
        bottom: '0',
        opacity: '0',
        borderRadius: '50%',
        padding: '2px',
        width: '20px',
        height: '20px',
        margin: '1.5px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
            background: '#b3c4d6bf'
        }
    },
    number: {
        fontSize: '13px',
        paddingLeft: '3px'
    },
    moreIcon: {
        marginRight: '5px'
    }
});
function AppointmentCell(props) {
    const classes = styles();
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const { pathname } = useLocation();
    const clinicId = pathname.split('/').filter((item) => item)[0];
    // const handleGoToDate = () => {
    //     const date = moment(props.date).format('YYYY-MM-DD');
    //     props.setDate(date);
    //     history.push('/appointment');
    // };
    const goPatientPage = (appointment) => {
        const id = appointment?.patient?.id;
        if (id) {
            history.push(`/${clinicId}/patient/${id}/profile`);
        }
    };
    const setAppointmentDateTime = async () => {
        const date = moment(props.date).format('YYYY-MM-DD');
        await props.setDate(date);
        const hour = props.hour.length === 1 ? '0' + props.hour + ':00' : props.hour + ':00';
        await props.setHour(hour);
        history.push(`/${clinicId}/patients`);
    };
    const handleOpenMenu = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div className={classes.cell}>
            <div className={classes.innerCellContainer}>
                {props.appointments?.map((appointment) => (
                    <div
                        key={appointment.id}
                        className={classes.cellItem}
                        onClick={() => goPatientPage(appointment)}
                    >
                        <div className={classes.name}>
                            {appointment?.patient.first_name} {appointment?.patient.last_name}
                        </div>
                        <div className={classes.time}>{getTime(appointment.appointed)}</div>
                    </div>
                ))}
            </div>

            <div className={classes.moreContainer}>
                {props.appointments?.length > 4 ? (
                    <>
                        <div className={classes.moreLink} onClick={handleOpenMenu}>
                            <span className={classes.number}>{props.appointments?.length - 4}</span>
                            <span>نوبت دیگر</span>
                            <img
                                width={4}
                                className={classes.moreIcon}
                                src={ARROW_ICON}
                                alt="prev-week"
                                ref={anchorRef}
                            />
                        </div>
                        {anchorRef && (
                            <AppointmentListMenu
                                open={open}
                                anchorEl={anchorRef}
                                appointments={props?.appointments}
                                closeMenu={handleClose}
                                handleRedirect={goPatientPage}
                            />
                        )}
                    </>
                ) : null}
                <div className={classes.plusLink}>
                    <img
                        onClick={setAppointmentDateTime}
                        width={18}
                        height={18}
                        alt="add"
                        src={ADD_ICON}
                    />
                </div>
            </div>
        </div>
    );
}
AppointmentCell.propTypes = {
    appointments: PropTypes.arrayOf(PropTypes.object),
    setDate: PropTypes.func,
    setHour: PropTypes.func,
    date: PropTypes.string,
    hour: PropTypes.number
};
const mapDispatchToProps = (dispatch) => bindActionCreators({ setDate, setHour }, dispatch);
export default connect(null, mapDispatchToProps)(AppointmentCell);
